"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_SCHEMA_VERSION = void 0;
exports.normalizeMediaReference = normalizeMediaReference;
exports.isMediaReady = isMediaReady;
exports.serializeWordpressGallery = serializeWordpressGallery;
exports.MEDIA_SCHEMA_VERSION = 1;
function normalizeMediaReference(input) {
    const id = String(input.id);
    const provider = input.provider ?? 'wordpress';
    const sourceUrl = input.sourceUrl ?? input.source_url ?? input.url;
    const parsedWordpressId = Number(id);
    const wordpressMediaId = input.wordpressMediaId
        ?? (provider === 'wordpress' && Number.isInteger(parsedWordpressId) ? parsedWordpressId : undefined);
    const width = Number(input.width);
    const height = Number(input.height);
    const hasDimensions = Number.isInteger(width) && width > 0 && Number.isInteger(height) && height > 0;
    return {
        id,
        provider,
        visibility: input.visibility ?? (provider === 'wordpress' ? 'published' : 'private'),
        ...(sourceUrl ? { sourceUrl } : {}),
        ...(input.thumbnailUrl ? { thumbnailUrl: input.thumbnailUrl } : {}),
        ...(wordpressMediaId !== undefined ? { wordpressMediaId } : {}),
        ...(hasDimensions ? { width, height } : {}),
    };
}
function isMediaReady(input) {
    if (input.provider === 'r2') {
        return input.id.length > 0;
    }
    return input.wordpressMediaId !== undefined && Boolean(input.sourceUrl);
}
function escapeAttribute(value) {
    return value
        .replaceAll('&', '&amp;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
}
function serializeWordpressGallery(inputs) {
    const references = inputs.map(normalizeMediaReference);
    const wordpressIds = references.flatMap((reference) => (reference.provider === 'wordpress' && reference.wordpressMediaId !== undefined
        ? [reference.wordpressMediaId]
        : []));
    const items = references.map((reference) => {
        if (!reference.sourceUrl || reference.visibility !== 'published') {
            throw new Error(`Media ${reference.id} must be published before WordPress serialization`);
        }
        const sourceUrl = escapeAttribute(reference.sourceUrl);
        if (reference.provider === 'wordpress') {
            if (reference.wordpressMediaId === undefined) {
                throw new Error(`WordPress media ${reference.id} is missing an attachment ID`);
            }
            return `<li class="blocks-gallery-item"><figure><img src="${sourceUrl}" alt="" data-id="${reference.wordpressMediaId}" class="wp-image-${reference.wordpressMediaId}"/></figure></li>`;
        }
        const size = reference.width && reference.height
            ? ` width="${reference.width}" height="${reference.height}"`
            : '';
        return `<li class="blocks-gallery-item"><figure><img src="${sourceUrl}" alt=""${size} data-media-provider="r2" data-media-id="${escapeAttribute(reference.id)}"/></figure></li>`;
    });
    const galleryHtml = `<figure class="wp-block-gallery"><ul class="blocks-gallery-grid">${items.join('')}</ul></figure>`;
    if (references.some((reference) => reference.provider === 'r2')) {
        const nestedImages = references.map((reference) => {
            const sourceUrl = escapeAttribute(reference.sourceUrl);
            const mediaDimensions = reference.width && reference.height
                ? { width: reference.width, height: reference.height }
                : {};
            const blockDimensions = reference.width && reference.height
                ? { width: String(reference.width), height: String(reference.height) }
                : {};
            const attributes = reference.provider === 'wordpress'
                ? { id: reference.wordpressMediaId, sizeSlug: 'full' }
                : {
                    url: reference.sourceUrl,
                    sizeSlug: 'full',
                    ...blockDimensions,
                    reportanMedia: {
                        id: reference.id,
                        provider: 'r2',
                        ...mediaDimensions,
                    },
                };
            const imageClass = reference.provider === 'wordpress'
                ? ` class="wp-image-${reference.wordpressMediaId}"`
                : '';
            const imageSize = reference.width && reference.height
                ? ` style="width:${reference.width};height:${reference.height}"`
                : '';
            const resizedClass = reference.width && reference.height ? ' is-resized' : '';
            return `<!-- wp:image ${JSON.stringify(attributes)} -->\n<figure class="wp-block-image${resizedClass} size-full"><img src="${sourceUrl}" alt=""${imageClass}${imageSize}/></figure>\n<!-- /wp:image -->`;
        });
        return `<!-- wp:gallery -->\n<figure class="wp-block-gallery has-nested-images columns-default is-cropped">${nestedImages.join('')}</figure>\n<!-- /wp:gallery -->`;
    }
    return `<!-- wp:gallery {"ids":[${wordpressIds.join(',')}]} -->\n${galleryHtml}\n<!-- /wp:gallery -->`;
}
